import SketchyPenPickerTypes from "../Types/SketchyPenPickerTypes"

const sketchyPenSizes: SketchyPenPickerTypes[] = [
    { name: "Small", size: 5 },
    { name: "Medium", size: 10 },
    { name: "Large", size: 13 }
]

export default sketchyPenSizes